import { decodeToHex, decrypt, getKeyFromPem } from './crypto';
export const decryptEncodedEncryptedHolderPassphrase = (encryptedBytesBase64, privateKey)=>{
    const encryptedBytes = decodeToHex(encryptedBytesBase64);
    const holderPassphrase = decrypt(encryptedBytes, privateKey, 'RSAOAEP512');
    return holderPassphrase;
};
export const getHolderEntry = ({ identity, encryptedPrivateKey, passphrase })=>{
    const privateKey = getKeyFromPem(encryptedPrivateKey, passphrase);
    return {
        holderUID: identity.holderUID,
        holderPassphrase: decryptEncodedEncryptedHolderPassphrase(identity.encryptedHolderPassphrase, privateKey)
    };
};
